import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const ArticleList = () => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    fetch("/articles.json")
      .then((res) => res.json())
      .then((data) => setArticles(data.filter(a => a.type === "Publication")));
  }, []);

  return (
    <>
      {articles.map((article) => (
        <article className="entry" key={article.id}>
          <div className="entry-img">
            <img src={article.image} alt="" className="img-fluid" />
          </div>
          <h2 className="entry-title">
            <Link to={article.readMoreLink}>{article.title}</Link>
          </h2>
          <div className="entry-meta">
            <ul>
              <li className="d-flex align-items-center">
                <i className="bi bi-person"></i>
                <a href="blog-single.html">{article.author}</a>
              </li>
              <li className="d-flex align-items-center">
                <i className="bi bi-clock"></i>
                <a href="blog-single.html">
                  <time dateTime="2020-01-01">{article.date}</time>
                </a>
              </li>
              <li className="d-flex align-items-center">
                <i className="bi bi-chat-dots"></i>
                <a href="blog-single.html">{article.comments}</a>
              </li>
            </ul>
          </div>
          <div className="entry-content">
            <p>{article.description}</p>
            <div className="read-more my-5">
              <Link to={article.readMoreLink}>Read More</Link>
              <a className="ml-3" href={article.downloadLink} download>
                Download
              </a>
            </div>
          </div>
        </article>
      ))}
    </>
  );
};

export default ArticleList;